
const deletedCode = {
    0: "사용",
    1: "탈퇴"
};

const loginTypeCode = {
    "LOCAL": "니드",
    "NAVER": "네이버",
    "KAKAO": "카카오",
};
const drSearchTypeCode = {
    "ALL" : "전체",
    "USER_KEY": "유저키",
    "ADDRESS": "주소",
};

const trSearchTypeCode = {
    "ALL" : "전체",
    "WITHDRAW_KEY" : "거래키",
    "TO" : "주소",
    "TRX_ID" : "txid"
};

const statusCode = {
    ALL: "전체",
    REQUEST: "요청",
    PENDING: "대기",
    SUCCESS: "성공",
    FAIL: "실패",
};
const signalTransactionStatusCode = {
    ALL: "전체",
    "PROCESSED": "처리완료",
    "NOT_PROCESSED": "대기"
};
const processedTypeCode = {
    
    0: "대기",
    1: "처리완료"
};
const filterCode = {
    ALL: "전체",
    TXID: "TXID",
    TO: "TO",
    FROM: "FROM",
};
const filterCodeWithdraw = {
    ALL: "전체",
    TO: "주소",
    FROM: "유저키",
};

const userTypeCode = {
    "ALL" : "전체",
    "USER_KEY": "유저키",
    // "": "주소",
};

const mergeLogCode = {
    "ALL" : "전체",
    "SUCCESS": "성공",
    "FAIL": "실패",
    "PENDING": "전송 중",
};

const ethFeeString = {
    0: "수수료 미보유",
    1: "수수료 보유",
  };

const requestString = {
    0: "요청 가능",
    1: "요청 중",
  };

const toggleCode = [0, 1]; 

export {
    deletedCode,
    loginTypeCode,
    drSearchTypeCode,
    trSearchTypeCode,
    statusCode,
    signalTransactionStatusCode,
    processedTypeCode,
    filterCode,
    filterCodeWithdraw,
    userTypeCode,
    mergeLogCode,
    ethFeeString,
    requestString,
    toggleCode
};